export const CounterAction = {
  INCREMENT: "INCREMENT",
  DECREMENT: "DECREMENT"
};

export const increment = () => ({ type: CounterAction.INCREMENT });

export const decrement = () => ({ type: CounterAction.DECREMENT });
